// LOCAL: placeholder section under StoreLayout — not implemented yet.
import { Card } from 'corso-admin-ui';
import { Mono, Section } from './RetoolPlaceholder';
import { StorePage } from './StorePage';

const steps = [
  ['Intro', 'overview / notes.'],
  ['Store Access', 'confirm Corso users have access.'],
  ['Checkout Plus Widget', 'verify widget installed.'],
  ['Customer Portal', 'verify portal configured.'],
  ['Corso Concierge', 'verify support integration.'],
  ['Billing', 'billing provider connected.'],
  ['Ticketing Integration', 'Zendesk / Front / Kustomer linked.'],
  ['Checkout Plus Pricing', 'pricing set assigned.'],
  ['Order Confirmation Email', '`shouldSendPurchaseConfirmation` toggle.'],
  ['Go Live', 'final approval flag.'],
] as const;

export default function OnboardingPage() {
  return (
    <StorePage title="Onboarding">
      <Card>
        <Card.Heading as="h2">Onboarding</Card.Heading>
        <Card.Description>
          Ten step cards the implementation team flips as they walk a merchant
          through go-live. Placeholder — wire up when the data lands.
        </Card.Description>

        <Section heading="Step cards">
          <ol className="ml-5 list-decimal space-y-1">
            {steps.map(([name, gist]) => (
              <li key={name}>
                <span className="font-medium text-neutral-900">{name}</span> —{' '}
                {gist}
              </li>
            ))}
          </ol>
        </Section>

        <Section heading="Controls (per card)">
          <p>
            Boolean <Mono>isComplete</Mono> toggle.
          </p>
          <p>
            Optional textarea <Mono>notes</Mono>.
          </p>
        </Section>

        <Section heading="Mutations">
          <p>
            Step toggles → <Mono>ADD_STORE_ONBOARDING_STEPS</Mono> (Hasura{' '}
            <Mono>insert_StoreOnboardingStep</Mono> / upsert on{' '}
            <Mono>storeId</Mono>).
          </p>
          <p>
            Order Confirmation Email toggle additionally fires{' '}
            <Mono>UPDATE_CONFIRMATION_EMAIL_STATUS</Mono> Hasura{' '}
            <Mono>
              MyMutation($storeId_eq: Int!, $shouldSendPurchaseConfirmation:
              Boolean!)
            </Mono>
            .
          </p>
          <p>
            “Prospect” status writes go through <Mono>UPDATE_PROSPECTS</Mono>.
          </p>
        </Section>
      </Card>
    </StorePage>
  );
}
